module.exports = __webpack_public_path__ + "img/member.fee88d49.svg";